import React, { Component } from 'react';
import { coverImage } from './PhotosRest';
import Media from './Media';

export default class AlbumEntry extends Component {
    constructor(props) {
	super(props);
	let active = props.showAlbum && parseInt(props.showAlbum, 10) === props.album.setId;
	this.state = {
	    album: props.album,
	    active: active
	};
	if (active) { props.showReset(); }
    }

    toggleMedia = m => this.setState({ active: !this.state.active });

    render() {
	return (<div className='album'>
		<div className='title' onClick={this.toggleMedia}>
		<span className='coverContainer'>
		<img className='cover' src={coverImage(this.state.album)} alt={this.state.album.name}/>
		</span>
		<span className='name'>{this.state.album.name}</span>
		</div>
		{this.state.active && <Media parentUrl={this.props.parentUrl} toggle={this.toggleMedia} album={this.state.album} chosenId={this.props.showPicture}/>}
		</div>);
    }
}
